import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { PartyPopper } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Shell } from "@/pages/Payment";
import { useTour } from "@/components/tour/TourProvider";

const T = {
  en: { title: "Welcome to GrantVerify", body: "Your account is ready. Next, we'll set up your workspace so we can match you with grants.", go: "Set up my workspace" },
  es: { title: "Bienvenido a GrantVerify", body: "Su cuenta está lista. Ahora configuraremos su espacio de trabajo para encontrarle subvenciones.", go: "Configurar mi espacio" },
};

export default function Welcome() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { lang } = useTour();
  const t = T[lang === "es" ? "es" : "en"];
  const raw = params.get("next") || "/dashboard";
  const next = raw.startsWith("/") && !raw.startsWith("//") ? raw : "/dashboard";
  useEffect(() => { const id = setTimeout(() => navigate(next, { replace: true }), 5000); return () => clearTimeout(id); }, [navigate, next]);
  return (
    <Shell>
      <PartyPopper className="h-12 w-12 text-emerald-600 mx-auto" />
      <h1 className="font-display text-3xl font-extrabold mt-6" data-testid="welcome-title">{t.title}</h1>
      <p className="text-slate-600 mt-2">{t.body}</p>
      <Link to={next} replace data-testid="welcome-continue-link"><Button className="mt-8 bg-emerald-600 hover:bg-emerald-700">{t.go}</Button></Link>
    </Shell>
  );
}
